var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarbagePowerup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.032 11.7708L101.229 37.9821V75.0367L75.032 101.229H37.9774L11.7708 75.032V37.9774L37.9774 11.7708H75.032ZM71.1288 21.1875H41.8759L21.1922 41.8806V71.1335L41.8759 91.8219H71.1288L91.8172 71.1335V41.8759L71.1288 21.1875ZM37.6667 51.7917H75.3333V61.2083H37.6667V51.7917Z",
    fill: "#413C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbagePowerup);
export default __webpack_public_path__ + "static/media/garbage-powerup.98d558aec9ddb921e78df991fcf12cfd.svg";
export { ForwardRef as ReactComponent };